// Autogenerated file
export const tripSheetAssignmentStatusesEnum = {
    Planned: "Planned",
    InProgress: "InProgress",
    Completed: "Completed",
    NotCompleted: "NotCompleted",
    Cancelled: "Cancelled",
};
export const tripSheetAssignmentStatuses = [
    { label: "Запланировано", value: "Planned" },
    { label: "Выполняется", value: "InProgress" },
    { label: "Выполнено", value: "Completed" },
    { label: "Не выполнено", value: "NotCompleted" },
    { label: "Отменено", value: "Cancelled" },
];
